import { Button, message } from "antd";
import React, { useEffect, useRef, useState } from "react";

const AddMemberPopup = ({
  isOpen,
  members,
  onClose,
  text = "Add Member to this organization",
  desc,
  buttonTextOne = "Add Member",
  buttonTextTwo,
  loading,
  handleSubmit,
  handleExistingMemberSubmit,
}) => {
  const formRef = useRef();
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const [existingMember, setExistingMember] = useState(null);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (formRef.current) {
      const inputs = formRef.current.querySelectorAll("input");
      inputs.forEach((input) => input.setAttribute("autocomplete", "off"));
    }
    if (emailRef.current) emailRef.current.value = "";
    if (passwordRef.current) passwordRef.current.value = "";
    setExistingMember(null);
    setShow(true);
  }, [isOpen]);

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const email = form.user_email?.value.trim();

    if (!isValidEmail(email)) {
      message.error("Invalid email format.");
      return;
    }

    const found = members?.find(
      (member) => member?.email?.toLowerCase() === email.toLowerCase()
    );

    if (found) {
      setExistingMember(found);
      const apps = [...(found?.modules || []), "Conversational AI"];
      const values = {
        MemberId: found?.Id,
        apps,
      };
      handleExistingMemberSubmit(values);
      return;
    }

    setShow(false);
    setExistingMember(null);

    const values = {
      email,
      password: form.user_password?.value,
      confirmPassword: form.confirmPassword?.value,
      firstName: form.firstName?.value.trim(),
      lastName: form.lastName?.value.trim(),
    };

    const nameRegex = /^[A-Za-z]+$/;

    if (!nameRegex.test(values.firstName)) {
      message.error("First name should contain only alphabets.");
      return;
    }

    if (!nameRegex.test(values.lastName)) {
      message.error("Last name should contain only alphabets.");
      return;
    }

    if (values.password.length < 6) {
      message.error("Password must be at least 6 characters long.");
      return;
    }

    if (values.password !== values.confirmPassword) {
      message.error("Passwords do not match.");
      return;
    }

    handleSubmit(values);
  };

  if (!isOpen) return null;

  const divStyle = {
    backgroundImage: "url(/popup-bg-image.svg)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    width: "100%",
  };

  return (
    <div className="fixed inset-0 bg-opacity-70 bg-black flex z-50 items-center justify-center">
      <div
        style={divStyle}
        className="bg-white fixed rounded-lg shadow-lg px-[1%] py-[1%] flex flex-col gap-1 items-center w-full h-auto max-w-2xl overflow-y-auto"
      >
        <img
          src="/cross-popup.svg"
          onClick={onClose}
          className="flex self-end w-10 cursor-pointer"
        />

        <h2 className="text-2xl font-medium px-8 text-black">{text}</h2>
        {desc && <p className="px-6 mt-1">{desc}</p>}

        <form
          ref={formRef}
          onSubmit={handleFormSubmit}
          className="w-[90%] mx-8 mt-4 flex flex-col gap-4"
          autoComplete="off"
        >
          <div className="flex flex-col">
            <label className="text-sm text-gray-700 mb-1">Email</label>
            <input
              name="user_email"
              ref={emailRef}
              type="email"
              required
              autoComplete="new-email"
              placeholder="Enter email"
              className="p-2 border border-gray-300 rounded custom-outline"
            />
          </div>

          {!existingMember && !show && (
            <>
              <div className="flex flex-col">
                <label className="text-sm text-gray-700 mb-1">First Name</label>
                <input
                  name="firstName"
                  type="text"
                  required
                  placeholder="Enter first name"
                  className="p-2 border border-gray-300 rounded custom-outline"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm text-gray-700 mb-1">Last Name</label>
                <input
                  name="lastName"
                  type="text"
                  required
                  placeholder="Enter last name"
                  className="p-2 border border-gray-300 rounded custom-outline"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm text-gray-700 mb-1">Password</label>
                <input
                  name="user_password"
                  ref={passwordRef}
                  type="password"
                  required
                  minLength={6}
                  placeholder="Enter password"
                  className="p-2 border border-gray-300 rounded custom-outline"
                />
              </div>

              <div className="flex flex-col">
                <label className="text-sm text-gray-700 mb-1">Confirm Password</label>
                <input
                  name="confirmPassword"
                  type="password"
                  required
                  placeholder="Confirm password"
                  className="p-2 border border-gray-300 rounded custom-outline"
                />
              </div>
            </>
          )}

          <div className="flex justify-center items-center gap-3 mt-5">
            <Button
              htmlType="submit"
              loading={loading}
              type="primary"
              className="primary custom-btn px-4 py-5 mb-4"
              style={{ borderRadius: "0px", transition: "none" }}
            >
              {buttonTextOne}
            </Button>

            {buttonTextTwo && (
              <button
                type="button"
                onClick={onClose}
                className="secondary px-4 py-2"
              >
                {buttonTextTwo}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddMemberPopup;
